const config = {
  mainFacility: 'f8164302-4b21-4fc0-a5c0-b898d9408074',
  googlePlaceId: 'ChIJexSN7DiLGGARcV-_JHR9AKY',
  assetsBucketUrl: 'https://s3.ap-northeast-1.amazonaws.com/net.cocodakara.bodydesign.assets/',
  recaptchaSiteKey: '6Le5swwtAAAAAFl-g_BbcTcXHcSRoHI_KJvy0ai9',
  v2PathPatternsToReload: [
    '/',
    '/terms-of-service',
    '/privacy-policy',
    '/faq',
    '/price',
    '/gallery',
    '/sign-in*',
    '/welcome*',
    '/verify*',
    '/403',
    '/account-unavailable*',
    '/my-page*',
    '/profile*',
    '/messages',
    '/messages/**',
    '/articles*',
    '/training-plan*',
    '/management',
    '/management/**',
    '/admin',
    '/admin/**',
  ],
};

export default config;
